// Mesh light theme for the auth flow (login/signup/reset/callback/setup) and
// the route-guard loading/error screens — these live outside .v2-root and
// previously used the legacy dark tokens from theme.ts.
// Keys intentionally mirror theme.ts `colors` so call sites can simply
// `import { meshColors as colors }` with minimal changes.
export const meshColors = {
  bgPrimary: '#FAFAFA', // page background
  bgSecondary: '#FFFFFF', // card background
  bgTertiary: '#FFFFFF', // input background

  borderDefault: '#E4E4E4',
  borderSubtle: '#F0F0F0',

  textPrimary: '#171717',
  textSecondary: '#6B6B6B',
  textMuted: '#6B6B6B',

  brand: '#3ECF8E',
  brandHover: '#3ECF8E',
  brandMuted: 'rgba(62, 207, 142, 0.12)',

  error: '#EF4444',

  // Primary CTA text on the #3ECF8E button
  buttonText: '#052E1C',
  // Text links (darker green for contrast on white)
  link: '#006239',

  // Mesh card ring + input focus glow
  cardRing: '0 0 0 1px rgba(23, 23, 23, 0.09)',
  focusRing: '0 0 0 3px rgba(62, 207, 142, 0.3)',

  fontSans:
    "'Geist', Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
} as const;
